import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ['target', 'checkbox'];

  change() {
    this.targetTarget.classList.toggle('hidden', !this.checkboxTarget.checked);
  }
}